import { useMutation } from 'react-query';
import { client } from '../../../actions';
import { authHeader } from '../../../helpers/auth-header';

const createCityPortalFiles = ({ files }) => {
  const url = '/Request/city_portal_files';
  return client.post(url, files, {
    headers: {
      ...authHeader(),
    },
  });
};

export const useCreateCityPortalFilesMutation = (options = {}) =>
  useMutation(createCityPortalFiles, {
    ...options,
  });
